import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ReactComponent as YoutubeIcon } from 'assets/icon-youtube.svg';

const CustomInput = React.forwardRef(
  (
    {
      type = 'text',
      placeholder,
      endAddonText,
      Icon = YoutubeIcon,
      className,
      value,
      defaultValue,
      onChange,
      name,
      isReadOnly,
      disabled,
    },
    ref
  ) => {
    return (
      <div className={classNames('d-flex flex-column', 'custom-input__main')}>
        <div className={classNames('d-flex flex-row-reverse')}>
          <div className={classNames(['custom-input__icon', className])}>
            <Icon />
          </div>
          {endAddonText && (
            <span className="input-group-text my-2" id="end-addon-text">
              {endAddonText}
            </span>
          )}
          <input
            ref={ref}
            type={type}
            placeholder={placeholder}
            className="my-2 pl-3"
            value={value}
            onChange={onChange}
            name={name}
            readOnly={isReadOnly}
            defaultValue={defaultValue}
            disabled={disabled}
          />
        </div>
      </div>
    );
  }
);

CustomInput.defaultProps = {
  className: '',
  value: undefined,
  placeholder: '',
  endAddonText: '',
  name: '',
  isReadOnly: false,
  defaultValue: undefined,
  disabled: false,
};

CustomInput.propTypes = {
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  endAddonText: PropTypes.string,
  Icon: PropTypes.func.isRequired,
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  isReadOnly: PropTypes.bool,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
};

export default CustomInput;
